/* Spinel Gem Therapy — Luxe theme JS
   Header pill shadow, reveal-on-scroll, mobile nav, curator's carousel. */

(function () {
  // ---------- Header pill: shadow grows once scrolled ----------
  const header = document.getElementById('siteHeader');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mobile nav drawer ----------
  const navToggle = document.getElementById('menuToggle');
  const mobileNav = document.getElementById('mobileNav');
  const mobileNavClose = document.getElementById('mobileNavClose');
  const navScrim = document.getElementById('navScrim');
  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    navScrim && navScrim.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    navScrim && navScrim.classList.remove('show');
    document.body.style.overflow = '';
  }
  navToggle && navToggle.addEventListener('click', openNav);
  mobileNavClose && mobileNavClose.addEventListener('click', closeNav);
  navScrim && navScrim.addEventListener('click', closeNav);

  // ---------- Reveal on scroll (gated so captures/print always show) ----------
  const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mqReduce.matches) {
    requestAnimationFrame(() => requestAnimationFrame(() => document.body.classList.add('anim')));
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // ---------- Newsletter "Thank you" affordance ----------
  document.querySelectorAll('form.field[data-newsletter]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('button');
      const input = form.querySelector('input[type="email"]');
      if (btn) btn.textContent = 'Thank you';
      if (input) input.value = '';
    });
  });
})();

/* ---------- Curator's carousel ---------- */
(function carousel() {
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const rail = root.querySelector('.carousel__rail');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const bar = root.querySelector('[data-carousel-progress]');
    const cur = root.querySelector('[data-carousel-current]');
    const total = root.querySelector('[data-carousel-total]');
    if (!rail) return;

    const cards = () => Array.from(rail.children);
    if (total) total.textContent = String(cards().length).padStart(2, '0');

    function step() {
      const c = cards()[0];
      if (!c) return 320;
      const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0);
      return c.getBoundingClientRect().width + gap;
    }
    function visible() {
      return Math.max(1, Math.round(rail.clientWidth / step()));
    }
    function update() {
      const v = visible();
      const n = cards().length;
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const pct = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
      const widthPct = Math.min(100, (v / n) * 100);
      if (bar) {
        bar.style.width = widthPct + '%';
        bar.style.left = pct * (100 - widthPct) + '%';
      }
      if (cur) cur.textContent = String(Math.round(rail.scrollLeft / step()) + 1).padStart(2, '0');
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= maxScroll - 2;
    }
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    rail.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next && next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev && prev.click(); }
    });
    // Drag-to-scroll with click suppression (only captures after 6px of travel)
    let down = false, dragging = false, suppressClick = false, startX = 0, startScroll = 0;
    rail.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      down = true; dragging = false;
      startX = e.clientX; startScroll = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 6) {
        dragging = true;
        rail.style.scrollSnapType = 'none';
      }
      if (dragging) {
        e.preventDefault();
        rail.scrollLeft = startScroll - dx;
      }
    });
    rail.addEventListener('click', (e) => {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    const endDrag = () => {
      if (!down) return;
      down = false;
      if (dragging) {
        rail.style.scrollSnapType = '';
        suppressClick = true;
        setTimeout(() => { suppressClick = false; }, 80);
        dragging = false;
      }
    };
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);

    update();
  });
})();
